import { render, staticRenderFns } from "./SessionCreateForm.vue?vue&type=template&id=045cdeda&scoped=true"
import script from "./SessionCreateForm.vue?vue&type=script&lang=js"
export * from "./SessionCreateForm.vue?vue&type=script&lang=js"
import style0 from "./SessionCreateForm.vue?vue&type=style&index=0&id=045cdeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045cdeda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow,VSpacer})
